"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.sizes = void 0;

var _stylitas = require("@creditas/stylitas");

const sizes = {
  xs: 320,
  sm: 360,
  md: 1024,
  lg: 1366,
  xl: 1920
};
exports.sizes = sizes;
const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => (0, _stylitas.css)`
    @media (min-width: ${sizes[label] / 16}em) {
      ${(0, _stylitas.css)(...args)}
    }
  `;

  return acc;
}, {});
exports.media = media;